import React from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';
import OverallPerformancePage from './OverallPerformancePage';

export default function IBManagementOverview() {
  return <OverallPerformancePage />;
}